<template>
  <div class="container mt-3">
    <h5 class="mb-3">个人资料</h5>
    <div class="mb-2">昵称：<b-form-input v-model="user_nick" size="sm" class="w-25 d-inline-block" disabled></b-form-input></div>
    <div class="mb-2">原密码：<b-form-input type="password" v-model="old_password" size="sm" class="w-25 d-inline-block"></b-form-input></div>
    <div class="mb-2">新密码：<b-form-input type="password" v-model="new_password1" size="sm" class="w-25 d-inline-block"></b-form-input></div>
    <div class="mb-2">确认新密码：<b-form-input type="password" v-model="new_password2" size="sm" class="w-25 d-inline-block"></b-form-input></div>
    <div class="mb-2 d-flex align-items-center">
      <!-- <img :src="avatarUrl" alt="avatar" style="width:60px;height:60px;border-radius:50%;object-fit:cover;border:1px solid #eee;" />
      <b-form-file v-model="file" accept="image/*" class="ml-3" browse-text="上传头像" @input="uploadAvatar"></b-form-file> -->
    </div>
    <b-button variant="primary" size="sm" @click="save">修改密码</b-button>
    <b-alert :show="msg!==''" variant="info" class="mt-2">{{ msg }}</b-alert>

    <hr class="my-4">
    <h5 class="mb-3">账号绑定</h5>
    <div class="mb-2 d-flex align-items-center">
      <span class="mr-3">微信：</span>
      <div v-if="wx_name" class="d-flex align-items-center">
        <img :src="wx_avatar" alt="wx" style="width:30px;height:30px;border-radius:50%;margin-right:10px;" v-if="wx_avatar"/>
        <span class="text-dark font-weight-bold">{{ wx_name }} (已绑定)</span>
      </div>
      <div v-else>
        <span class="text-muted mr-2">未绑定</span>
        <b-button variant="outline-success" size="sm" @click="showBindModal">立即绑定</b-button>
      </div>
    </div>
    
    <div class="mb-2 d-flex align-items-center">
      <span class="mr-3">邮箱：</span>
      <div v-if="email" class="d-flex align-items-center">
        <span class="text-dark font-weight-bold">{{ email }} (已绑定)</span>
      </div>
      <div v-else>
        <span class="text-muted mr-2">未绑定</span>
        <b-button variant="outline-success" size="sm" @click="showEmailBindModal">立即绑定</b-button>
      </div>
    </div>

    <!-- 微信绑定弹窗 -->
    <b-modal v-model="showWxModal" title="绑定微信" hide-footer centered @shown="onModalShown">
      <div class="text-center">
        <div id="wx-qrcode" style="min-height: 300px;"></div>
        <p class="text-muted mt-2">请使用微信扫一扫进行绑定</p>
      </div>
    </b-modal>

    <!-- 邮箱绑定弹窗 -->
    <b-modal v-model="showEmailModal" title="绑定邮箱" @ok="bindEmail" centered>
        <b-form-group label="邮箱地址" label-for="email-input">
            <b-form-input id="email-input" v-model="inputEmail" type="email" placeholder="请输入邮箱地址" required></b-form-input>
        </b-form-group>
        <b-form-group label="验证码" label-for="code-input">
            <div class="d-flex">
                <b-form-input id="code-input" v-model="verificationCode" placeholder="请输入6位验证码" required></b-form-input>
                <b-button variant="outline-primary" class="ml-2" style="min-width: 120px;" :disabled="countdown > 0" @click="sendVerificationCode">
                    {{ countdown > 0 ? `${countdown}s 后重试` : '获取验证码' }}
                </b-button>
            </div>
        </b-form-group>
    </b-modal>

    <!-- ======================================================= -->
    <!-- 接口 Token 模块                                          -->
    <!-- ======================================================= -->
    <hr class="my-4">
    <h5 class="mb-3">接口 Token</h5>
    <div>参考文档:<a href="https://github.com/zzquant/zzshare">https://github.com/zzquant/zzshare</a></div>
    <div class="token-card p-3 rounded border bg-light">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <span class="text-muted small">用于 zzshare SDK 鉴权，请求头：<code>sdk-key</code></span>
        <span v-if="userPoints !== null" class="badge badge-info">
          积分：{{ userPoints }}
        </span>
      </div>

      <!-- Token 显示行 -->
      <div class="d-flex align-items-center token-row">
        <code class="token-display flex-grow-1 mr-2 p-2 rounded border bg-white text-break">
          {{ tokenVisible ? apiToken : tokenMasked }}
        </code>
        <!-- 眼睛图标 -->
        <b-button id="btn-token-eye" variant="outline-secondary" size="sm" class="mr-1" @click="tokenVisible = !tokenVisible"
          :title="tokenVisible ? '隐藏 Token' : '显示 Token'">
          <span v-if="tokenVisible">🙈</span>
          <span v-else>👁</span>
        </b-button>
        <!-- 复制图标 -->
        <b-button id="btn-token-copy" variant="outline-primary" size="sm" class="mr-1" @click="copyToken"
          :title="tokenCopied ? '已复制' : '复制 Token'">
          {{ tokenCopied ? '✓ 已复制' : '📋' }}
        </b-button>
        <!-- 刷新图标 -->
        <b-button id="btn-token-refresh" variant="outline-danger" size="sm" @click="showRefreshConfirm = true"
          title="刷新 Token（旧 Token 立即失效）">
          🔄
        </b-button>
      </div>

      <!-- 订阅信息 -->
      <div v-if="activeSubs.length > 0" class="mt-2">
        <small class="text-muted">有效订阅：</small>
        <span v-for="sub in activeSubs" :key="sub.id" class="badge badge-success mr-1">
          {{ sub.plan_name }}（截止 {{ sub.end_date }}）
        </span>
      </div>

      <!-- 使用示例 -->
      <div class="mt-2 text-muted small">
        SDK 使用示例：
        <code class="d-block mt-1 p-2 rounded border bg-white text-dark">api = DataApi(token='{{ tokenVisible ? apiToken : "your_token" }}')</code>
      </div>

      <!-- 限额说明 (表格形式) -->
      <div v-if="tokenLimits.length > 0" class="mt-3">
        <div class="text-muted small mb-2">当前限额明细：</div>
        <div class="table-responsive">
          <table class="table table-sm table-bordered bg-white mb-0 text-center small">
            <thead class="bg-light text-muted">
              <tr>
                <th>接口能力</th>
                <th>限额 (次/分)</th>
                <th>权益说明 / 备注</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="lim in tokenLimits" :key="lim.endpoint">
                <td><code class="text-primary">{{ lim.endpoint }}</code></td>
                <td class="font-weight-bold">{{ lim.limit_per_min }}</td>
                <td class="text-left"><span class="text-muted">{{ lim.description || '默认规则' }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Token 刷新确认弹窗 -->
    <b-modal
      v-model="showRefreshConfirm"
      title="确认刷新 Token"
      ok-title="确认刷新"
      ok-variant="danger"
      cancel-title="取消"
      centered
      @ok="doRefreshToken"
    >
      <p>⚠️ <strong>刷新后旧 Token 将立即失效</strong>，所有正在使用旧 Token 的程序需要更新为新 Token。</p>
      <p class="text-muted mb-0">确认继续？</p>
    </b-modal>
  </div>
</template>

<script>
import { request_zzquant } from 'network/request.js'
export default {
  data(){ 
    return { 
      user_nick:'', 
      old_password:'', 
      new_password1:'', 
      new_password2:'', 
      avatarUrl:'', 
      file:null, 
      msg:'',
      // WeChat binding data
      wx_name: '',
      wx_avatar: '',
      showWxModal: false,
      wechatQrInited: false,
      // Email binding data
      email: '',
      showEmailModal: false,
      inputEmail: '',
      verificationCode: '',
      countdown: 0,
      timer: null,
      // Token 管理
      apiToken: '',
      tokenVisible: false,
      tokenCopied: false,
      userPoints: null,
      tokenLimits: [],     // [{endpoint, limit_per_min}]
      activeSubs: [],      // [{id, plan_name, end_date, ...}]
      showRefreshConfirm: false,
    } 
  },
  computed: {
    tokenMasked() {
      if (!this.apiToken) return '加载中...';
      const len = this.apiToken.length;
      return this.apiToken.substring(0, 4) + '*'.repeat(Math.max(0, len - 8)) + this.apiToken.substring(len - 4);
    }
  },
  mounted(){ this.load() },
  methods:{
    load(){ 
      request_zzquant({ url:'/user/profile/me' }).then(res=>{ 
        const d=res.data&&res.data.data?res.data.data:{}; 
        this.user_nick=d.user_nick||''; 
        this.avatarUrl=d.avatar_url||this.full(d.avatar); 
        this.wx_name = d.wx_name || '';
        this.wx_avatar = d.wx_avatar || '';
        this.email = d.email || '';
      });
      this.loadToken();
      this.loadPoints();
      this.loadSubscriptions();
    },

    // ── Token ─────────────────────────────────────────────────
    loadToken() {
      request_zzquant({ url: '/v3/user/token' }).then(res => {
        const d = res.data && res.data.data ? res.data.data : {};
        this.apiToken = d.token || '';
      }).catch(() => {
        this.apiToken = '';
      });
    },

    async copyToken() {
      if (!this.apiToken) return;
      try {
        await navigator.clipboard.writeText(this.apiToken);
        this.tokenCopied = true;
        setTimeout(() => { this.tokenCopied = false; }, 2000);
      } catch (e) {
        // 降级方案（旧浏览器）
        const el = document.createElement('textarea');
        el.value = this.apiToken;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        this.tokenCopied = true;
        setTimeout(() => { this.tokenCopied = false; }, 2000);
      }
    },

    doRefreshToken() {
      request_zzquant({ url: '/v3/user/token/refresh', method: 'POST' }).then(res => {
        const d = res.data && res.data.data ? res.data.data : {};
        this.apiToken = d.token || '';
        this.tokenVisible = true;  // 刷新后短暂显示新 token
        this.msg = '✅ Token 已刷新，旧 Token 已立即失效';
        setTimeout(() => { this.tokenVisible = false; }, 5000);
      }).catch(err => {
        this.msg = '刷新失败：' + (err.message || '未知错误');
      });
    },

    // ── Points + Limits ───────────────────────────────────────
    loadPoints() {
      request_zzquant({ url: '/v3/user/points' }).then(res => {
        const d = res.data && res.data.data ? res.data.data : {};
        this.userPoints = d.points !== undefined ? d.points : null;
        this.tokenLimits = d.limits || [];
      }).catch(() => {});
    },

    // ── Subscriptions ─────────────────────────────────────────
    loadSubscriptions() {
      request_zzquant({ url: '/v3/user/subscriptions' }).then(res => {
        const d = res.data && res.data.data ? res.data.data : {};
        this.activeSubs = d.subscriptions || [];
      }).catch(() => {});
    },

    // ── Password / Avatar ─────────────────────────────────────
    uploadAvatar(){ if(!this.file) return; const form=new FormData(); form.append('file',this.file); request_zzquant({ url:'/user/profile/avatar/upload', method:'POST', data:form, headers:{ 'Content-Type':'multipart/form-data' } }).then(res=>{ const url=res.data&&res.data.data?res.data.data.url:null; if(url){ this.avatarUrl=url; this.file=null; try{ const raw=localStorage.getItem('user_info'); const info=raw?JSON.parse(raw):{}; info.avatar_url=url; localStorage.setItem('user_info', JSON.stringify(info)); window.dispatchEvent(new CustomEvent('user-login', { detail: { userInfo: info } })); }catch(e){ this.msg = '头像已更新，但本地信息刷新失败'; } } }) },
    save(){ if(!this.old_password||!this.new_password1||!this.new_password2){ this.msg='请输入完整的密码信息'; return } request_zzquant({ url:'/user/profile/password', method:'POST', data:{ old_password:this.old_password, new_password1:this.new_password1, new_password2:this.new_password2 } }).then(()=>{ this.msg='密码已更新'; this.old_password=''; this.new_password1=''; this.new_password2=''; }) },
    full(u){ if(!u) return ''; if(u.startsWith('http')) return u; return 'https://api.zizizaizai.com'+u },
    
    showBindModal() {
      this.showWxModal = true;
    },
    onModalShown() {
      if (!this.wechatQrInited) {
        this.initWeChatQr();
      }
    },
    async initWeChatQr() {
      try {
        await this.loadWxLoginScript()
        const appid = process.env.VUE_APP_WECHAT_QR_APPID || 'wx45ac2ee1309c6e44'
        const origin = process.env.VUE_APP_WECHAT_REDIRECT_ORIGIN || window.location.origin
        const redirectPath = '/login/wx/bind/callback'
        const redirectUri = encodeURIComponent(`${origin}${redirectPath}`)
        
        /* global WxLogin */
        new WxLogin({
          id: 'wx-qrcode',
          appid,
          scope: 'snsapi_login',
          redirect_uri: redirectUri,
          state: 'bind',
          style: 'black',
          href: ''
        })
        this.wechatQrInited = true
      } catch (e) {
        console.error('初始化微信二维码失败', e)
        this.msg = '加载微信二维码失败，请稍后重试'
      }
    },
    loadWxLoginScript() {
      return new Promise((resolve, reject) => {
        if (window.WxLogin) {
          resolve()
        } else {
          const script = document.createElement('script')
          script.type = 'text/javascript'
          script.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'
          script.onload = () => resolve()
          script.onerror = () => reject()
          document.head.appendChild(script)
        }
      })
    },
    showEmailBindModal() {
        this.inputEmail = '';
        this.verificationCode = '';
        this.showEmailModal = true;
    },
    sendVerificationCode() {
        if (!this.inputEmail) {
            this.msg = '请输入邮箱地址';
            return;
        }
        if (this.inputEmail.indexOf('@') === -1 || this.inputEmail.indexOf('.') === -1) {
            this.msg = '邮箱格式不正确';
            return;
        }
        
        request_zzquant({
            url: '/user/profile/email/code',
            method: 'POST',
            data: { email: this.inputEmail }
        }).then(res => {
            const msg = res.data && res.data.data ? res.data.data : '验证码已发送';
            this.msg = msg;
            
            this.countdown = 60;
            this.timer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
            }, 1000);
        }).catch(err => {
             const errorMsg = err.response && err.response.data && err.response.data.msg ? err.response.data.msg : (err.message || '发送失败');
             this.msg = errorMsg;
        });
    },
    bindEmail(bvModalEvt) {
        bvModalEvt.preventDefault();
        if (!this.inputEmail) {
            this.msg = '请输入邮箱地址';
            return;
        }
        if (!this.verificationCode) {
            this.msg = '请输入验证码';
            return;
        }
        
        request_zzquant({
            url: '/user/profile/email/bind',
            method: 'POST',
            data: { 
                email: this.inputEmail,
                code: this.verificationCode
            }
        }).then(() => {
            this.msg = '邮箱绑定成功';
            this.email = this.inputEmail;
            this.showEmailModal = false;
        }).catch(err => {
             const errorMsg = err.response && err.response.data && err.response.data.msg ? err.response.data.msg : (err.message || '绑定失败');
             this.msg = errorMsg;
        });
    }
  }
}
</script>

<style>
.token-card {
  max-width: 640px;
}
.token-display {
  font-size: 13px;
  font-family: 'Courier New', monospace;
  word-break: break-all;
  min-height: 38px;
  display: flex;
  align-items: center;
}
.token-row {
  flex-wrap: wrap;
}
</style>

